export default function isDuplicatePiece(tracks, currentPieceId) {
  return (
    tracks.map(track => track.piece.id).filter(pieceId => pieceId === currentPieceId).length > 1
  );
}
